export const getQrCodeUrl = (doctorId: string) => {
  const qrCodePreurl = 'https://m.healthjd.com/health_forward?path=/pages/login/wv-common/wv-common?h5_url='

  const qrCodeUrl = doctorId ? `${qrCodePreurl}${
    encodeURIComponent(
      `https://laputa.healthjd.com/doctor_home/doctorHome/home?doctorId=${doctorId}`
    )
  }` : ""
  return qrCodeUrl;
}


export const getQrCodeListUrl = (url: string) => {
  const qrCodePreurl = 'https://m.healthjd.com/health_forward?path=/pages/login/wv-common/wv-common?h5_url='

  const qrCodeUrl = url ? `${qrCodePreurl}${
    encodeURIComponent(url)
  }` : ""
  return qrCodeUrl;
}